import React from "react";
import { NavLink } from "react-router-dom";
import PropTypes from "prop-types";

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import Slide from "@material-ui/core/Slide";
import cx from "classnames";

// @material-ui/icons
import Check from "@material-ui/icons/Check";
// import LockOutline from "@material-ui/icons/LockOutline";

// core components
import GridContainer from "components/Grid/GridContainer";
import GridItem from "components/Grid/GridItem";
import Button from "components/CustomButtons/Button";
import { formatMoney, formatDate, shortenDealId } from "utils/Utils";
import brandTheme from "brandTheme/Theme";
import { Grid } from "@material-ui/core";

const style = (theme) => ({
  container: {
    fontWeight: 400,
    maxWidth: 1800,
  },
  center: {
    textAlign: "center",
    margin: 20,
    marginTop: 40,
  },
  checkIcon: {
    color: "#A5DC86",
    border: "solid 4px",
    borderRadius: 22,
    padding: 2,
    fontSize: 44,
    borderColor: "aquamarine",
  },
  closeButton: {
    position: "absolute",
    right: theme.spacing(1),
    top: 32,
    color: theme.palette.grey[500],
  },
  titleContent: {
    paddingTop: 5,
    paddingLeft: 10,
    position: "absolute",
  },
  loginModalTitle: {
    fontWeight: 600,
    textAlign: "left",
    color: brandTheme.buttonColor,
  },
  subTitle: {
    fontWeight: 400,
    fontSize: "16px",
  },
  floatLeft: {
    //float: "left",
    //textAlign: "start",
  },
  floatRight: {
    float: "right",
  },
  floatNone: {
    float: "none",
  },
  alignLeft: {
    textAlign: "left",
  },
  alignRight: {
    textAlign: "right",
  },
  detailsHeader: {
    textAlign: "left",
    marginBottom: 20,
    fontSize: 18,
  },
  detailsRow: {
    //marginTop: 10,
    color: "black",
    // paddingRight: 15,
    textAlign: "start",
  },
  selectLabel: {
    fontSize: 14,
    textTransform: "none",
    color: "#AAAAAA !important",
    //top: 7
  },
  select: {
    paddingBottom: 10,
    fontSize: 14,
  },
  selectFormControl: {
    [theme.breakpoints.up("lg")]: {
      marginTop: -15,
    },
  },
  countryFormControl: {
    marginTop: 5,
  },
  modalCloseButton: {
    float: "right",
  },
  loginMaxWidth: {
    maxWidth: 650,
    paddingBottom:"40px",
  },
  // closeButton: {
  //   position: "absolute",
  //   right: theme.spacing(1),
  //   top: theme.spacing(1),
  //   color: theme.palette.grey[500],
  // },
  emptyIcon: {
    [theme.breakpoints.up("lg")]: {
      display: "none",
    },
  },
  // alignRight: {
  //   textAlign: "right",
  // },
});

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="down" ref={ref} {...props} />;
});

class LoanDetails extends React.Component {
  constructor(props) {
    super(props);
    // we use this to make the card to appear after the page has been rendered
    this.state = {
      cardAnimaton: "cardHidden",
      showModal: true,
      documentLink: "google.com",
    };
  }
  handleClickOpen() {
    this.setState({ showModal: true });
  }
  handleClose() {
    this.props.closeModal();
    //this.setState({ showModal: false });
  }
  handleLoginSubmit() {
    this.setState({
      showModal: false,
      otpModal: true,
    });
  }
  componentDidMount() {
    // we add a hidden class to the card and after 700 ms we delete it and the transition appears
    this.timeOutFunction = setTimeout(
      function () {
        this.setState({ cardAnimaton: "" });
      }.bind(this),
      700
    );
  }
  // componentDidUpdate(e) {
  //   if (this.state.showModal === this.props.showModal) {
  //     e.history.go(-1);
  //   }
  // }
  static getDerivedStateFromProps(props, state) {
    if (props.showModal !== state.showModal) {
      return {
        showModal: props.showModal,
      };
    }
    return null;
  }
  componentWillUnmount() {
    clearTimeout(this.timeOutFunction);
    this.timeOutFunction = null;
  }
  getDocumentLink = (link) => {
    return (
      <a href={link} target="_blank" rel="noopener noreferrer">
        Open Link
      </a>
    );
  };

  render() {
    const { classes, trade } = this.props;
    const { showModal } = this.state;
    return trade ? (
      <div className={classes.container}>
        <Dialog
          maxWidth="xl"
          style={{width:"100%"}}
          open={showModal}
          
          disableEscapeKeyDown
          TransitionComponent={Transition}
          keepMounted
          onClose={() => this.handleClose()}
          aria-labelledby="classic-modal-slide-title"
          aria-describedby="classic-modal-slide-description"
        >
          <DialogTitle
            id="classic-modal-slide-title"
            disableTypography
            className={cx(classes.modalHeader)}
          >
            <IconButton
              aria-label="close"
              className={classes.closeButton}
              onClick={() => this.handleClose()}
            >
              <CloseIcon />
            </IconButton>
            <h3 className={cx(classes.modalTitle, classes.loginModalTitle)}>
              {/* <Check className={classes.checkIcon} /> */}
              <span className={(classes.titleContent, classes.floatLeft)}>
                Loan Details
              </span>
            </h3>
          </DialogTitle>

          <DialogContent
            id="classic-modal-slide-description"
            className={cx(classes.modalBody, classes.loginMaxWidth)}
          >
            <Grid item xs={12} sm={12} md={12} className={classes.inputContainer}>
        <Grid container className={classes.inputFieldContainer}>
        <Grid item xs={12} sm={12} md={6} className={classes.fieldContaienr}>
        <p style={{ marginBottom: 0 }}>
              <b>Request Number</b>
            </p>
            <label>{trade.loanRequestNum}</label>

        </Grid>
        <Grid item xs={12} sm={12} md={6} className={classes.fieldContaienr}>
        <p style={{ marginBottom: 0 }}>
              <b>Name</b>
            </p>
            <label>{trade.name}</label>

        </Grid>
        <Grid item xs={12} sm={12} md={6} className={classes.fieldContaienr}>
        <p style={{ marginBottom: 0 }}>
              <b>Mobile</b>
            </p>
            <label>{trade.mobileNumber}</label>

        </Grid>
        <Grid item xs={12} sm={12} md={6} className={classes.fieldContaienr}>
        <p style={{ marginBottom: 0 }}>
              <b>Loan Amount</b>
            </p>
            <label>{trade.proposedLoanAmt}</label>

        </Grid>
          </Grid></Grid>
            {/* <GridContainer>
              <GridItem xs={12} sm={12} md={12} lg={12}>
                <GridContainer justifyContent="flex-start" className={classes.content}>
                  <GridItem
                    xs={12}
                    sm={12}
                    md={12}
                    lg={12}
                    className={classes.alignRight}
                  >
                    <div className={classes.detailsHeader}> </div>
                    <GridContainer>
                      <GridItem
                        className={classes.detailsRow}
                        xs={5}
                        sm={5}
                        md={5}
                        lg={5}
                      >
                        <span className={classes.floatLeft}>
                          Request Number
                        </span>
                      </GridItem>
                      <GridItem
                        xs={7}
                        sm={7}
                        md={7}
                        lg={7}
                        className={classes.detailsRow}
                      >
                        {" "}
                        <span>{trade.loanRequestNum}</span>
                      </GridItem>
                    </GridContainer>

                    <React.Fragment>
                      <GridContainer>
                        <GridItem
                          className={classes.detailsRow}
                          xs={5}
                          sm={5}
                          md={5}
                          lg={5}
                        >
                          <span className={classes.floatLeft}>Name</span>
                        </GridItem>
                        <GridItem
                          xs={7}
                          sm={7}
                          md={7}
                          lg={7}
                          className={classes.detailsRow}
                        >
                          <span>{trade.name}</span>
                        </GridItem>
                      </GridContainer>

                      <GridContainer>
                        <GridItem
                          className={classes.detailsRow}
                          xs={5}
                          sm={5}
                          md={5}
                          lg={5}
                        >
                          <span className={classes.floatLeft}>Mobile</span>
                        </GridItem>
                        <GridItem
                          xs={7}
                          sm={7}
                          md={7}
                          lg={7}
                          className={classes.detailsRow}
                        >
                          <span>{trade.mobileNumber}</span>
                        </GridItem>
                      </GridContainer>
                      <GridContainer>
                        <GridItem
                          xs={5}
                          sm={5}
                          md={5}
                          lg={5}
                          className={classes.detailsRow}
                        >
                          <span className={classes.floatLeft}>Loan Amount</span>
                        </GridItem>
                        <GridItem
                          xs={7}
                          sm={7}
                          md={7}
                          lg={7}
                          className={classes.detailsRow}
                        >
                          <span>{trade.proposedLoanAmt}</span>
                        </GridItem>
                      </GridContainer>
                      <GridContainer>
                        <GridItem
                          className={classes.detailsRow}
                          xs={5}
                          sm={5}
                          md={5}
                          lg={5}
                        >
                          <span className={classes.floatLeft}>Address</span>
                        </GridItem>
                        <GridItem
                          xs={7}
                          sm={7}
                          md={7}
                          lg={7}
                          className={classes.detailsRow}
                        >
                          <span>{trade.address}</span>
                        </GridItem>
                      </GridContainer>
                    </React.Fragment>
                  </GridItem>
                </GridContainer>
              </GridItem>
            </GridContainer> */}
          </DialogContent>
        </Dialog>
      </div>
    ) : (
      <></>
    );
  }
}

LoanDetails.propTypes = {
  classes: PropTypes.object,
  showModal: PropTypes.bool,
  closeModal: PropTypes.func,
  trade: PropTypes.object,
};

export default withStyles(style)(LoanDetails);
